import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: {
  charges: {
    waitingCharge: string;
    ambulanceCharge: string;
    oxygenCharge: string;
    others: string;
    helper: number;
    wheelchair: boolean;
    stretcher: boolean;
    paramedic: boolean;
    doctorOnBoard: boolean;
  };
  dropLocations: any[];
} = {
  charges: {
    waitingCharge: "",
    ambulanceCharge: "",
    oxygenCharge: "",
    others: "",
    helper: 0,
    wheelchair: false,
    stretcher: false,
    paramedic: false,
    doctorOnBoard: false
  },
  dropLocations: []
};

const extraChargesSlice = createSlice({
  name: "extraCharges",
  initialState,
  reducers: {
    setCharges: (state, action: PayloadAction<any>) => {
      state.charges = { ...state.charges, ...action.payload };
    },
    setDropLocations: (state, action: PayloadAction<any[]>) => {
      state.dropLocations = action.payload;
    },
    addDropLocation: (state, action: PayloadAction<any>) => {
      state.dropLocations.push(action.payload);
    },
    updateDropLocation: (state, action: PayloadAction<{ index: number; location: any }>) => {
      state.dropLocations[action.payload.index] = action.payload.location;
    },
    removeDropLocation: (state, action: PayloadAction<number>) => {
      state.dropLocations = state.dropLocations.filter((_, i) => i !== action.payload);
    },
    clearExtraCharges: (state) => {
      state.charges = initialState.charges;
      state.dropLocations = [];
    }
  }
});

export const {
  setCharges,
  setDropLocations,
  addDropLocation,
  updateDropLocation,
  removeDropLocation,
  clearExtraCharges
} = extraChargesSlice.actions;

export default extraChargesSlice.reducer;
